import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreProviderComponent } from './store-provider.component';
import { reducers } from './redux/reducers/shared.reducer';
import { StoreModule } from '@ngrx/store';
import { LocalesService } from './services/locales.service';
import {EffectsModule} from "@ngrx/effects";
import {sharedLibEffects} from "./redux/effects";
import {LoyaltySharedService} from "./services/loyalty.service";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('shared', reducers),
    EffectsModule.forFeature(sharedLibEffects)
  ],
  declarations: [StoreProviderComponent],
  exports: [StoreProviderComponent],
  providers: [LocalesService, LoyaltySharedService],
})
export class StoreProviderModule {}
